export enum MessageTypeEnum {
  deal = 'Deal',
  offers = 'Offers',
  referral = 'Referral',
  sendaSnack = 'SendaSnack',
};
